import React from 'react'

type IconProps = React.SVGProps<SVGSVGElement>

export const DownloadAlt = (props: IconProps) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 9H16C15.4 9 15 9.4 15 10C15 10.6 15.4 11 16 11H18C18.6 11 19 11.4 19 12V19C19 19.6 18.6 20 18 20H6C5.4 20 5 19.6 5 19V12C5 11.4 5.4 11 6 11H8C8.6 11 9 10.6 9 10C9 9.4 8.6 9 8 9H6C4.3 9 3 10.3 3 12V19C3 20.7 4.3 22 6 22H18C19.7 22 21 20.7 21 19V12C21 10.3 19.7 9 18 9ZM8.3 14.7L11.3 17.7C11.5 17.9 11.7 18 12 18C12.3 18 12.5 17.9 12.7 17.7L15.7 14.7C16.1 14.3 16.1 13.7 15.7 13.3C15.3 12.9 14.7 12.9 14.3 13.3L13 14.6V3C13 2.4 12.6 2 12 2C11.4 2 11 2.4 11 3V14.6L9.7 13.3C9.3 12.9 8.7 12.9 8.3 13.3C7.9 13.7 7.9 14.3 8.3 14.7Z"
      fill="currentColor"
    />
  </svg>
)

export default DownloadAlt
